import * as React from 'react';
import styled from 'styled-components';
import { blackColour, brandingColourLight, tabletPortraitMinWidth, whiteColour } from '../../../cssConstants';

const PublicSquareButton = ({ logo, mainText, subText, selected, onClick }: Props) => {
	return (
		<ButtonContainer $selected={selected} onClick={onClick}>
			<Logo src={logo} alt={mainText} />
			<MainText>{mainText}</MainText>
			<SubText>{subText}</SubText>
		</ButtonContainer>
	);
};

export default PublicSquareButton;

interface Props {
	logo?: unknown;
	mainText?: string;
	subText?: string;
	selected: boolean;
	onClick?: () => void;
}

const ButtonContainer = styled.div<{ $selected: boolean }>`
	width: 250px;
	height: 230px;
	background-color: ${({ $selected }) => ($selected ? brandingColourLight : whiteColour)};
	border: 1px solid #ccc;
	border-radius: 30px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: all 0.3s ease;

	@media (min-width: ${tabletPortraitMinWidth}) {
		width: 400px;
		height: 350px;
	}

	&:hover {
		background-color: ${brandingColourLight};
		transform: scale(1.05); /* Slightly enlarge on hover */
	}
`;

const Logo = styled.img`
	width: 80px;
	height: 80px;
	margin-bottom: 20px;

	@media (min-width: ${tabletPortraitMinWidth}) {
		width: 100px;
		height: 100px;
	}
`;

const MainText = styled.p`
	margin: 0;
	font-size: 20px;
	font-weight: bold;
	text-align: center;
	margin-bottom: 20px;
	color: ${blackColour};

	@media (min-width: ${tabletPortraitMinWidth}) {
		font-size: 25px;
	}
`;

const SubText = styled.p`
	margin: 0;
	font-size: 16px;
	text-align: center;
	color: ${blackColour};

	@media (min-width: ${tabletPortraitMinWidth}) {
		font-size: 18px;
	}
`;
